<template>
  <div class="page">
    <div class="operation">
      <DiluButton type="add" :title="$t('pages.equipment.text335')" @click="add" v-permission="['errCode:add']"/>
      <DiluButton type="custom" @click="i18nImport" :title="$t('button.i18nImport')" icon="el-icon-upload2" v-permission="['errCode:import']"/>
    </div>
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
    >
      <el-table-column
        prop="errorCode"
        :label="$t('menu.errCode')"
        width="100px"
        align="center"
      />
      <el-table-column
        prop="errorName"
        :label="$t('pages.equipment.text355')"
        width="200px"
        align="center"
      />
      <el-table-column
        prop="hwType"
        :label="$t('pages.equipment.text339')"
        :formatter="formatData"
        width="110px"
        align="center"
      />
      <el-table-column
        prop="langZh"
        :label="$t('pages.equipment.text340')"
        width="80px"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="editZh(scope.row)" type="text">{{ scope.row.langZh=='yes'?$t("button.edit"):$t("button.create")}}</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="langEn"
        :label="$t('pages.equipment.text341')"
        width="80px"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="editEn(scope.row)" type="text">{{ scope.row.langEn=='yes'?$t("button.edit"):$t("button.create")}}</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="langJa"
        :label="$t('pages.equipment.text342')"
        width="80px"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="editJa(scope.row)" type="text">{{ scope.row.langJa=='yes'?$t("button.edit"):$t("button.create")}}</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="langDe"
        :label="$t('pages.equipment.text346')"
        width="80px"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="editDe(scope.row)" type="text">{{ scope.row.langDe=='yes'?$t("button.edit"):$t("button.create")}}</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="langPt"
        :label="$t('pages.equipment.text343')"
        width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="editPt(scope.row)" type="text">{{ scope.row.langPt=='yes'?$t("button.edit"):$t("button.create")}}</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="langPl"
        :label="$t('pages.equipment.text344')"
        width="80px"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="editPl(scope.row)" type="text">{{ scope.row.langPl=='yes'?$t("button.edit"):$t("button.create")}}</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="langHr"
        :label="$t('pages.equipment.text345')"
        width="100px"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="editHr(scope.row)" type="text">{{ scope.row.langHr=='yes'?$t("button.edit"):$t("button.create")}}</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        width="140px"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="edit(scope.row)" type="text">{{ $t("button.edit") }}</el-button>
            <el-button @click="del(scope.row)" type="text">{{ $t("button.delete") }}</el-button>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 错误代码 -->
    <ErrorCodeAdd 
      @dialogClose="dialogClose" 
      :dialogVisible="dialogVisible" 
      :codeInfo="codeInfo"
      @codeList="codeList"/>

    <!-- 多语言定义 -->
    <LangEdit 
      @dialogClose="dialogClose" 
      :langVisible="langVisible" 
      :codeInfo="codeInfo" 
      @codeList="codeList"/>

    <LangImport
      @dialogClose="dialogClose"
      :codeInfo="codeInfo"
      :importVisible="importVisible"
      @codeList="codeList"
    />  

  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import ErrorCodeAdd from "./module/errorCodeAdd";
import LangEdit from "./module/langEdit"; 
import LangImport from "./module/langImport"; 
import { mapState } from "vuex";
export default {
  data() {
    return {
      codeInfo: {},
      protocolId: 0,
      dialogVisible: false,
      langVisible: false,
      editorVisible: false,
      importVisible: false,
      tableConfig: {
        isTree: false,
        isPage: false,
      },
      tableData: [],
    };
  },
  components: {
    DiluTable,
    DiluButton,
    ErrorCodeAdd,
    LangEdit,
    LangImport
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    this.protocolId = this.$route.query.protocolId;
    this.codeList();
  },
  methods: {
    editZh(row) { //中文
      this.codeInfo={
        "lang": "zh",
        "protocolId": row.protocolId,
        "errorCode": row.errorCode,
        "hwType": row.hwType,
      }
      this.langVisible=true;
    },
    editEn(row) { //英语
      this.codeInfo={
        "lang": "en",
        "protocolId": row.protocolId,
        "errorCode": row.errorCode,
        "hwType": row.hwType,
      }
      this.langVisible=true;
    },
    editJa(row) { //日语
      this.codeInfo={
        "lang": "ja",
        "protocolId": row.protocolId,
        "errorCode": row.errorCode,
        "hwType": row.hwType,
      }
      this.langVisible=true;
    },
    editHr(row) { //克罗地亚语
      this.codeInfo={
        "lang": "hr",
        "protocolId": row.protocolId,
        "errorCode": row.errorCode,
        "hwType": row.hwType,
      }
      this.langVisible=true;
    },
    editPl(row) { //波兰语
      this.codeInfo={
        "lang": "pl",
        "protocolId": row.protocolId,
        "errorCode": row.errorCode,
        "hwType": row.hwType,
      }
      this.langVisible=true;
    },
    editPt(row) { //葡萄牙语
      this.codeInfo={
        "lang": "pt",
        "protocolId": row.protocolId,
        "errorCode": row.errorCode,
        "hwType": row.hwType,
      }
      this.langVisible=true;
    },
    editDe(row) { //德语
      this.codeInfo={
        "lang": "de",
        "protocolId": row.protocolId,
        "errorCode": row.errorCode,
        "hwType": row.hwType,
      }
      this.langVisible=true;
    },
    //格式化内容显示
    formatData(row) {
        if (row.hwType=='10') {
          return this.$t("pages.equipment.text178");;
        } else if (row.hwType=='15') {
          return this.$t("pages.equipment.text202");
        } else if (row.hwType=='20') {
          return this.$t("pages.equipment.text203");
        } else if (row.hwType=='25') {
          return this.$t("pages.equipment.text204");
        } else if (row.hwType=='30') {
          return this.$t("pages.equipment.text205");
        } else if (row.hwType=='35') {
          return this.$t("pages.equipment.text206");
        } else if (row.hwType=='40') {
          return this.$t("pages.equipment.text207");
        } else if (row.hwType=='45') {
          return this.$t("pages.equipment.text208");
        } else if (row.hwType=='50') {
          return this.$t("pages.equipment.text347");
        } else if (row.hwType=='55') {
          return this.$t("pages.equipment.text348");
        } else if (row.hwType=='60') {
          return this.$t("pages.equipment.text349");
        } else if (row.hwType=='65') {
          return this.$t("pages.equipment.text350");
        } else if (row.hwType=='70') {
          return this.$t("pages.equipment.text362");
        } else {
          return "";
        }
    },
    //获取错误代码列表
    codeList() {
      var params={
        "protocolId": this.protocolId
      }
      this.request.codeList(params).then((res) => {
        this.tableData = res.data;
      });
    },
    //关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
      this.langVisible = false;
      this.importVisible = false;
    },
    //关闭超文本编辑弹窗
    editorClose() {
      this.editorVisible = false;
      this.langVisible = true;
    },
    //重置
    reset() {
      this.codeList();
    },
    //新增
    add() {
      this.codeInfo = {
        "protocolId": this.protocolId
      };
      this.dialogVisible = true;
    },
    //导入
    i18nImport() {
      this.codeInfo={
        "protocolId": this.protocolId
      }
      this.importVisible = true;
    },
    //删除
    del(e) {
      this.$confirm(
        this.$t("pages.equipment.text360"),
        this.$t("public.text6"),
        {
          confirmButtonText: this.$t("button.determine"),
          cancelButtonText: this.$t("button.cancel"),
          type: "warning",
        }
      )
      .then(() => {
        this.request.errCodeDelete({
            protocolId: e.protocolId,
            errorCode: e.errorCode
        }).then(() => {
          this.codeList();
          this.$message({
            type: "success",
            message: this.$t("public.text7"),
          });
        });
      })
      .catch(() => {});
    },
    //修改
    edit(e) {
      this.codeInfo = e;
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-slot i {
  font-size: 20px;
}
</style>